// Accordion
// ----------------------------------------------------------------

import $ from 'jquery';

$('.js-accordionTrigger').on('click', function() {
  let id = $(this)[0].getAttribute('aria-controls');

  if (! $('#control-' + id).is(':visible')) {
    // Close all accordions
    $('.js-accordionTrigger').each(function() {
        $(this)[0].ariaExpanded = false;
        $(this).parents('.u-stack-md').find('.js-accordionTarget').slideUp(250);
    });

    // Open requested accordion
    $(this)[0].ariaExpanded = true;
    $('#control-' + id).slideDown(250);
  }
  else {
    // Close requested accordion
    $(this)[0].ariaExpanded = false;
    $('#control-' + id).slideUp(250);
  }
});
